import React from 'react';

/**
 * Phase 18.1 — Verified Creator badge.
 * Shown next to usernames of creators whose Stripe Connect KYC is complete
 * AND whose monetization has not been suspended by the admin.
 *
 * Pure SVG so it remains crisp at any size and inherits the gold palette
 * (#D4AF37). A subtle shimmer keyframe animates the highlight gradient.
 */
const VerifiedBadge = ({ size = 14, className = '', title = 'Voce Pro' }) => (
  <span
    className={`verified-creator-badge inline-flex shrink-0 items-center justify-center align-middle ${className}`}
    title={title}
    aria-label={title}
    data-testid="verified-creator-badge"
    style={{ width: size, height: size }}
  >
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <defs>
        <linearGradient id="vcb-gold" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor="#F2D688" />
          <stop offset="50%" stopColor="#D4AF37" />
          <stop offset="100%" stopColor="#B8902A" />
        </linearGradient>
      </defs>
      <path
        d="M12 2.2 14.5 4l3 .2.6 3 2.1 2.3-1.4 2.7.5 3-2.8 1.3-1.7 2.5-3-.5-2.7 1.4-2.3-2.1-3-.6-.2-3L2.2 12l1.8-2.5-.2-3 3-.6L9.1 4l2.9-1.8Z"
        fill="url(#vcb-gold)"
        stroke="#8B6A1F"
        strokeWidth="0.6"
      />
      <path
        d="M8.3 12.2 10.8 14.7 16 9.4"
        stroke="#1A1208"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </span>
);

export default VerifiedBadge;
